@if (data()?.customComponent) {
  <ng-container [ngComponentOutlet]="data().customComponent"></ng-container>
} @else {
  <div class="no-data-con" [class]="data()?.class">
    @let img = data()?.img;
    <svg class="no-data-icon">
      <use [attr.href]="img ?? '../../../../assets/nodata.svg'"></use>
    </svg>
    <div class="no-data-con2">
      @if (data()?.title) {
        <div class="h5 gray">{{ data().title }}</div>
      }
      @if (data()?.message) {
        <div class="fs-14 gray text-center text-preline">{{ data().message }}</div>
      }
      @if (data()?.actions?.length) {
        <div class="d-flex justify-content-center mt-3">
          <pf-action-group [actions]="data()?.actions" [componentRef]="this" [limit]="data()?.actions?.length"
            cssClass="justify-content-center gap-2"></pf-action-group>
        </div>
      }
    </div>
  </div>
}
